import { createContext } from 'react';

/**
 * Contexto das estatísticas de alcance dos nós do fluxo.
 * `enabled`: se o modo Stats está ligado (mostra os badges).
 * `stats`: mapa { node_id: quantidade de pessoas que chegaram }.
 */
export const FlowStatsContext = createContext({ enabled: false, stats: {} });
